<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-account-tie"
      title="Sobre Nosotros"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>

        <!-- <v-carousel>
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
      reverse-transition="fade-transition"
      transition="fade-transition"
    ></v-carousel-item>
  </v-carousel> -->

    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'La Empresa',
          subtitle: 'Importación y Distribución de Abrasivos, preparación de Superficies, Asesoría Técnica durante preparación de superficies.',
          text: 'Comercial C&D Group Limitada nace en Chile, del entusiasmo de dos hermanos con espíritu empresarial y su padre con una vasta experiencia en Mercado de comercialización de Pinturas de alta performance en áreas Marinas e industrial en América del Sur,  y viendo la necesidad de utilizar un abrasivo para el tratamiento de la superficie, y que éste no fuese  nocivo para los operarios que realizan este proceso, y ecológicamente amigable con el medio ambiente; cumpliendo todas las normativas ambientales tanto en Chile como a nivel Internacional.Vender soluciones técnicas de última generación, con nuestro apoyo técnico comercial permanente, que beneficie al cliente final en duración de los esquemas aplicados, menor tiempo durante la preparación de superficie, ya sea para corte por agua o  aplicación de pinturas, lo que implica mayor productividad para nuestros clientes.  ',
          callout: 'E',
        },
        {
          title: 'Misión',
          subtitle: 'Cliente, Efectividad y Liderazgo',
          text: 'Crear una nueva mentalidad en el tratamiento de superficies, que no sean nocivas para operario que granalla, amigable con el medio ambiente, y con un costo/beneficio adecuado a sus clientes.En Chile, desde el 24 de enero del año 2005 bajo decreto de Ministerio de Salud; Subsecretaria de Salud Pública se prohibió el arenado.En Brasil, la Ley que prohíbe  el arenado, rige  desde 20 Octubre del año 2004.En Argentina, en Septiembre del 2019 se prohíbe el uso de arena seca y/o húmeda en todo el territorio de esta Nación, para las tareas de arenado abrasivo. Las Empresas importantes y preocupadas por salud de operarios y medio ambiente como YPF ya solicitaban con anterioridad el abrasivo Garnet para exterior de sus tuberías.La misión es establecer relaciones comerciales con clientes claves del mercado nacional y llegar a ser una referencia en el logro de sus propias metas y concretar sus proyectos de forma oportuna y con material de calidad. Nuestra misión es satisfacer las necesidades de nuestros clientes con soluciones técnicas adecuadas a sus necesidades, que se puedan implementar rápidamente y proporcionar beneficios  en cuanto a productividad y calidad del trabajo, yendo más allá de lo mínimo requerido por las especificaciones.Abastecer nuestro producto de primera calidad, en tiempo y forma, ayudando a nuestros clientes a ser cada vez más productivas sus operaciones, brindándoles el asesoramiento técnico necesario en todas las obras que se ejecuten con nuestro producto Garnet.',
          callout: 'M',
        },
        {
          title: 'Visión',
          subtitle: 'Logistica, Servicio y Calidad',
          text: 'Ser el punto de referencia para el suministro de abrasivos en Chile y América del Sur, proporcionando beneficios efectivos y satisfacción total al cliente.Brindar un excelente Servicio Logístico, con stock de productos en tiempo y forma.Comercializar productos de calidad comprobada y Certificada.Lograr ser aliado estratégico de nuestros Clientes y Empresas que respaldamos.',
          callout: 'V',
        },
      ],
       items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
    }),
  }
</script>
